<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="128"
    height="109"
    viewBox="0 0 128 109"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_496"
          data-name="Rectangle 496"
          width="128"
          height="109"
          transform="translate(817 303)"
          fill="#fff"
          stroke="#707070"
          stroke-width="1"
        />
      </clipPath>
    </defs>
    <g
      id="Mask_Group_12"
      data-name="Mask Group 12"
      transform="translate(-817 -303)"
      clip-path="url(#clip-path)"
    >
      <g
        id="Group_1842"
        data-name="Group 1842"
        transform="translate(846 311.5)"
      >
        <g
          id="Group_1822"
          data-name="Group 1822"
          transform="translate(56.815 60.546)"
        >
          <g
            id="Group_1821"
            data-name="Group 1821"
          >
            <rect
              id="Rectangle_494"
              data-name="Rectangle 494"
              width="2.728"
              height="9.55"
              transform="translate(0 1.929) rotate(-45)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1824"
          data-name="Group 1824"
          transform="translate(61.639 65.371)"
        >
          <g
            id="Group_1823"
            data-name="Group 1823"
          >
            <path
              id="Path_114"
              data-name="Path 114"
              d="M311.3,336.389a7.559,7.559,0,0,1-5.584-2.469L290,316.65a6.451,6.451,0,0,1,.212-8.917l.068-.068a6.461,6.461,0,0,1,8.919-.212l17.27,15.711a7.548,7.548,0,0,1,.259,10.92l-.092.092A7.509,7.509,0,0,1,311.3,336.389ZM294.851,308.5a3.708,3.708,0,0,0-2.64,1.095l-.068.068a3.732,3.732,0,0,0-.124,5.155l15.711,17.268a4.822,4.822,0,0,0,6.974.165l.092-.092a4.819,4.819,0,0,0-.165-6.974l-17.27-15.712A3.709,3.709,0,0,0,294.851,308.5Z"
              transform="translate(-288.317 -305.77)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1826"
          data-name="Group 1826"
          transform="translate(0 21.097)"
        >
          <g
            id="Group_1825"
            data-name="Group 1825"
          >
            <path
              id="Path_115"
              data-name="Path 115"
              d="M60.674,111.89a21.2,21.2,0,0,1,2.084,2.427V98.68H0v71.284H62.758V157.272l-1.454-1.6a9.263,9.263,0,0,1-1.274-1.789v13.353H2.728V101.41h57.3v9.864C60.248,111.473,60.464,111.681,60.674,111.89Z"
              transform="translate(0 -98.68)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1828"
          data-name="Group 1828"
          transform="translate(2.728 10.548)"
        >
          <g
            id="Group_1827"
            data-name="Group 1827"
          >
            <path
              id="Path_116"
              data-name="Path 116"
              d="M70.062,57.16H67.334V52.068H15.49V57.16H12.76V49.34h57.3Z"
              transform="translate(-12.76 -49.34)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1830"
          data-name="Group 1830"
          transform="translate(5.458)"
        >
          <g
            id="Group_1829"
            data-name="Group 1829"
          >
            <path
              id="Path_117"
              data-name="Path 117"
              d="M77.374,7.82h-2.73V2.728H28.258V7.82H25.53V0H77.374Z"
              transform="translate(-25.53)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1832"
          data-name="Group 1832"
          transform="translate(11.461 32.622)"
        >
          <g
            id="Group_1831"
            data-name="Group 1831"
          >
            <path
              id="Path_118"
              data-name="Path 118"
              d="M74.617,152.59a20.927,20.927,0,0,0-1.89,1.683c-.338.338-.665.688-.975,1.045H53.61V152.59Z"
              transform="translate(-53.61 -152.59)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1834"
          data-name="Group 1834"
          transform="translate(11.461 42.72)"
        >
          <g
            id="Group_1833"
            data-name="Group 1833"
          >
            <path
              id="Path_119"
              data-name="Path 119"
              d="M53.61,199.82H67.56a20.571,20.571,0,0,0-.695,2.728H53.61Z"
              transform="translate(-53.61 -199.82)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1836"
          data-name="Group 1836"
          transform="translate(11.461 52.815)"
        >
          <g
            id="Group_1835"
            data-name="Group 1835"
          >
            <path
              id="Path_120"
              data-name="Path 120"
              d="M66.784,247.04a20.833,20.833,0,0,0,.633,2.728H53.61V247.04Z"
              transform="translate(-53.61 -247.04)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1838"
          data-name="Group 1838"
          transform="translate(11.461 62.912)"
        >
          <g
            id="Group_1837"
            data-name="Group 1837"
          >
            <path
              id="Path_121"
              data-name="Path 121"
              d="M74.072,297H53.61V294.27H71.374a19.686,19.686,0,0,0,1.353,1.492Q73.375,296.413,74.072,297Z"
              transform="translate(-53.61 -294.27)"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1840"
          data-name="Group 1840"
          transform="translate(11.461 73.007)"
        >
          <g
            id="Group_1839"
            data-name="Group 1839"
          >
            <rect
              id="Rectangle_495"
              data-name="Rectangle 495"
              width="39.838"
              height="2.728"
              fill="#333"
            />
          </g>
        </g>
        <g
          id="Group_1820"
          data-name="Group 1820"
          transform="translate(27.079 30.803)"
        >
          <g
            id="Group_1819"
            data-name="Group 1819"
          >
            <path
              id="Path_113"
              data-name="Path 113"
              d="M145.206,181.188a18.554,18.554,0,1,1,13.12-5.435A18.436,18.436,0,0,1,145.206,181.188Zm0-34.38a15.825,15.825,0,1,0,11.19,4.635A15.722,15.722,0,0,0,145.206,146.808Z"
              transform="translate(-126.66 -144.08)"
              fill="#eb2a2e"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'NoResults'
}
</script>
